import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GraphAnnotationModel } from '../../../core/api/models';
import {
  AnnotationLabelBackgroundOption,
  annotationSupportsLabelPosition,
  graphAnnotationDisplayLabel,
  resolveAnnotationLabelPositionValue,
} from '../../graph-annotation-display.utils';

@Component({
  selector: 'app-annotation-display-panel',
  templateUrl: './annotation-display-panel.component.html',
  styleUrl: './annotation-display-panel.component.css',
  standalone: false,
})
export class AnnotationDisplayPanelComponent {
  @Input() annotations: GraphAnnotationModel[] = [];
  @Input() displayAnnotations = true;
  @Input() displayAutomaticAnnotations = true;
  @Input() displayUserAnnotations = true;
  @Input() canAddAnnotation = false;
  @Input() showAnnotationDisplayOptions = false;
  @Input() isLoadingGraph = false;
  @Input() annotationLabelBackground: AnnotationLabelBackgroundOption =
    AnnotationLabelBackgroundOption.Transparent;
  @Input() annotationLabelBackgroundOptions: {
    label: AnnotationLabelBackgroundOption;
    value: AnnotationLabelBackgroundOption;
  }[] = [];
  @Input() declutterAnnotations = false;
  @Input() isAnnotationDisplayed: (annotation: GraphAnnotationModel) => boolean = () => true;

  @Output() displayAnnotationsChange = new EventEmitter<boolean>();
  @Output() displayAutomaticAnnotationsChange = new EventEmitter<boolean>();
  @Output() displayUserAnnotationsChange = new EventEmitter<boolean>();
  @Output() annotationDisplayChange = new EventEmitter<{ annotation: GraphAnnotationModel; isDisplayed: boolean }>();
  @Output() addAnnotation = new EventEmitter<void>();
  @Output() editAnnotation = new EventEmitter<GraphAnnotationModel>();
  @Output() annotationLabelBackgroundChange = new EventEmitter<AnnotationLabelBackgroundOption>();
  @Output() declutterAnnotationsChange = new EventEmitter<boolean>();
  @Output() labelPositionChange = new EventEmitter<{
    annotation: GraphAnnotationModel;
    labelPosition: 'start' | 'middle' | 'end';
  }>();

  automaticAnnotations() {
    return this.annotations.filter((annotation) => annotation.IsAutomatic);
  }

  userAnnotations() {
    return this.annotations.filter((annotation) => !annotation.IsAutomatic);
  }

  annotationLabel(annotation: GraphAnnotationModel): string {
    return graphAnnotationDisplayLabel(annotation);
  }

  onAnnotationDisplayChange(annotation: GraphAnnotationModel, isDisplayed: boolean) {
    this.annotationDisplayChange.emit({ annotation, isDisplayed });
  }

  supportsLabelPosition(annotation: GraphAnnotationModel): boolean {
    return annotationSupportsLabelPosition(annotation);
  }

  currentLabelPosition(annotation: GraphAnnotationModel): 'start' | 'middle' | 'end' {
    return resolveAnnotationLabelPositionValue(annotation);
  }

  onLabelPositionSelected(
    annotation: GraphAnnotationModel,
    labelPosition: 'start' | 'middle' | 'end'
  ): void {
    if (this.currentLabelPosition(annotation) === labelPosition) {
      return;
    }
    this.labelPositionChange.emit({ annotation, labelPosition });
  }
}
